import { uploadFileWithThumbnailUrl } from '@/constants';
import instanceAxios from '@/util/axios';
import { Box } from '@mui/material';
import { InputFile } from '@sm-dashboard/form-provider';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

interface EventImageUploadProps {
  initialImageUrl?: string;
  initialThumbnailUrl?: string;
}

export const EventImageUpload = ({ initialImageUrl, initialThumbnailUrl }: EventImageUploadProps) => {
  const [assetImage, setAssetImage] = useState<File | string | (File | string)[]>('');
  const { setValue } = useFormContext();

  const handleImageChange = async (file: File) => {
    if (file) {
      setAssetImage(file);
      const formData = new FormData();
      formData.append('file', file);
      try {
        const { data } = await instanceAxios.post(uploadFileWithThumbnailUrl, formData);
        const imageUrl = data?.url || data?.publicUrl;
        if (imageUrl) {
          setValue('image', imageUrl);
          // Set the uploaded image URL directly for preview
          setAssetImage(imageUrl);
        }
        const thumbnailUrl = data?.thumbnailUrl;
        if (thumbnailUrl) {
          setValue('thumbnail', thumbnailUrl);
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    } else {
      setAssetImage('');
      setValue('image', '');
      setValue('thumbnail', '');
    }
  };

  return (
    <Box sx={{ '& > *': { alignItems: 'flex-start' }, border: '1px dashed grey', borderRadius: 1 }}>
      <InputFile
        id="event-image-upload"
        title="העלאת תמונת המוקד"
        file={assetImage}
        setFile={file => handleImageChange(file as File)}
        isImage
        initialPreviewUrls={
          !assetImage && initialThumbnailUrl && initialImageUrl
            ? [{ thumbnail: initialThumbnailUrl, image: initialImageUrl }]
            : []
        }
        openDialogOnImageClick
      />
    </Box>
  );
};
